import * as React from 'react';

import { BannersRow } from '../../components/BannersRow';
import { CarouselOverlayPanel } from '../../components/CarouselOverlayPanel';
import { DoubleColumnLayout } from '../../components/DoubleColumnLayout';
import { FixedHeader } from '../../components/FixedHeader';
import { GenplanNavContainer } from '../../components/Genplan/components/GenplanNavContainer';
import { PageLayout } from '../../components/PageLayout';
import { PageRowLayout } from '../../components/PageRowLayout';
import { useApplicationContext } from '../../utils/applicationContext';
import { AboutContainer } from '../About';
import { AdvantagesContainer } from '../Advantages';
import { AerialViewContainer } from '../AerialView';
import { BasicInfoContainer } from '../BasicInfo';
import { BuilderCallReasonsContainer } from '../BuilderCallReasons';
import { BreadCrumbsContainer } from '../BreadCrumbs';
import { BuilderChatPopupContainer } from '../BuilderChatPopup';
import { BuildersInfoContainer } from '../BuildersInfo';
import { CarouselContainer } from '../Carousel';
import { CompanySeoCard } from '../CompanySeoCard';
import { ComparisonContainer } from '../Comparison';
import { COMPARISON_ENTRYPOINTS_ENABLED_CONFIG } from '../Comparison/constants';
import { NewbuildingActionsContainer } from '../NewbuildingActions';
import { EscrowContainer } from '../Escrow';
import { FeaturesContainer } from '../Features';
import { FlatViewOrderTooltipContainer } from '../FlatViewOrderTooltip';
import { ImageSources } from '../ImageSources';
import { InteriorDecorationContainer } from '../InteriorDecoration';
import { LabelsContainer } from '../Labels';
import { LastHopePopupContainer } from '../LastHopePopup';
import { MortgageSectionContainer } from '../MortgageSection';
import { InfrastructureContainer } from '../InfrastructureContainer';
import { NewbuildingFromTheBuilderContainer } from '../NewbuildingFromTheBuilder';
import { NewbuildingReviewsTeaserContainer } from '../NewbuildingReviewsTeaser';
import { OffersBlockContainer } from '../OffersBlock';
import { PromoDetailsContainer } from '../PromoDetails';
import { PromosSectionContainer } from '../PromosSection';
import { RealtyValuationContainer } from '../RealtyValuation';
import { RecommendedNewbuildingsContainer } from '../RecommendedNewbuildings';
import { RightColumnContainer } from '../RightColumn';
import { SpecificationsDetailedContainer } from '../SpecificationsDetailed';
import { FloorPlanLoadable } from '../FloorPlan/FloorPlanLoadable';
import { GenplanLoadable } from '../Genplan/GenplanLoadable';
import { OffersStatsContainer } from '../OffersStats';
import { ReliabilityV2Container } from '../ReliabilityV2';
import { SeoMarkedListContainer } from '../SeoMarkedList';
import { MessageButtonContainer } from '../MessageButton';
import { MortgageMiniCalculatorWidget } from '../MortgageMiniCalculatorWidget';
import { ConsultantChatPopupContainer } from '../ConsultantChatPopupContainer';
import { CallToActionContainer } from '../CallToAction';
import { NewbuildingSeoBlockContainer } from '../NewbuildingSeoBlock';

/**
 * Страница для ЖК на CPL и ЖК "Скоро в продаже".
 */
export const StandardPage: React.FC = () => {
  const { config } = useApplicationContext();
  const mortgageMiniCalculatorEnabled = config.get<boolean>('Newbuilding.MortgageMiniCalculator.Enabled');
  const comparisonEntrypointsEnabled = config.get<boolean>(COMPARISON_ENTRYPOINTS_ENABLED_CONFIG) || false;

  return (
    <>
      <PageLayout>
        <FixedHeader
          actionButton={
            <CallToActionContainer
              dynamicCalltrackingPlaceType="blockStickyTop"
              analyticOnOpenActionName="Open_jk_card_blockStickytop"
              XXL
            />
          }
          messageButton={
            <MessageButtonContainer
              isHeaderButton={true}
              asIcon={false}
              buttonSize="M"
              buttonTheme="fill_secondary"
              placeType="Open_jk_card_blockStickytop"
            />
          }
        />
        <BreadCrumbsContainer />
        <CarouselOverlayPanel />
        <CarouselContainer />
        <FlatViewOrderTooltipContainer />

        <PageRowLayout>
          <DoubleColumnLayout
            rightColumn={<RightColumnContainer dynamicCalltrackingPlaceType="blockStickyRightTop" />}
            topContent
          >
            <LabelsContainer />
            <BasicInfoContainer />
            {comparisonEntrypointsEnabled ? (
              <BannersRow>
                <BuilderCallReasonsContainer />
                <ComparisonContainer />
              </BannersRow>
            ) : (
              <>
                <BuilderCallReasonsContainer />
                <NewbuildingActionsContainer />
              </>
            )}
            <GenplanNavContainer>
              <GenplanLoadable />
            </GenplanNavContainer>
            <FloorPlanLoadable />
            <AerialViewContainer />
            <OffersBlockContainer />
            <PromosSectionContainer />
            {mortgageMiniCalculatorEnabled ? <MortgageMiniCalculatorWidget /> : <MortgageSectionContainer />}
            <RealtyValuationContainer />
            <AboutContainer />
            <AdvantagesContainer />
            <NewbuildingReviewsTeaserContainer />
          </DoubleColumnLayout>

          <InfrastructureContainer />

          <DoubleColumnLayout
            rightColumn={<RightColumnContainer dynamicCalltrackingPlaceType="blockStickyRightBottom" />}
          >
            <SpecificationsDetailedContainer />
            <InteriorDecorationContainer />
            <BuildersInfoContainer />
            <NewbuildingFromTheBuilderContainer />
            <FeaturesContainer />
            <ReliabilityV2Container />
            <EscrowContainer />
            <OffersStatsContainer />
            <RecommendedNewbuildingsContainer />
            <ImageSources />
            <SeoMarkedListContainer />
            <ConsultantChatPopupContainer />
          </DoubleColumnLayout>
        </PageRowLayout>

        <DoubleColumnLayout rightColumn={null}>
          <PageRowLayout>
            <NewbuildingSeoBlockContainer />
          </PageRowLayout>
        </DoubleColumnLayout>
      </PageLayout>
      <BuilderChatPopupContainer />
      <LastHopePopupContainer />
      <PromoDetailsContainer />
      <CompanySeoCard />
    </>
  );
};
